var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle-statistic',{attrs:{"icon":"shopping_basket","title":_vm.$t('customs.dashboard.averageBasket'),"sub-title":_vm.subtitle,"value":_vm.periodDiffPositiveValue,"text":_vm.formatPrice(_vm.averageBasket, _vm.currency),"color":_vm.color,"caption":_vm.periodDiffIsInfinity
      ? ''
      : _vm.$t('customs.dashboard.previousPeriod') + ' ' + _vm.formatPrice(_vm.averageBasketPrevious, _vm.currency),"is-negative":Math.sign(_vm.percentagePeriodDiff) !== 1,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }